export const ru = {
    'archived-experiment-name': 'Эксперимент {experimentId}'
};
